"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propertyName = exports.checkIsPropertyNameUnique = exports.uniquePropertyName = void 0;

var _builder = _interopRequireDefault(require("../../../utils/builder"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var uniquePropertyName = 'uniquePropertyName';
exports.uniquePropertyName = uniquePropertyName;

var checkIsPropertyNameUnique = function checkIsPropertyNameUnique(component, setting, value, data) {
  var formKeys = _builder.default.getFormKeys(component.root.editForm, data);

  var key = value.toLowerCase();
  return !(formKeys.hasOwnProperty(key) && formKeys[key] !== data.id);
};

exports.checkIsPropertyNameUnique = checkIsPropertyNameUnique;
var propertyName = {
  weight: 0,
  type: 'textfield',
  input: true,
  key: 'key',
  label: 'Property Name',
  tooltip: 'The name of this field in the API endpoint.',
  validate: {
    pattern: '(\\w|\\w[\\w-.]*\\w)',
    patternMessage: 'The property name must only contain alphanumeric characters, underscores, dots and dashes and should not be ended by dash or dot.',
    custom: uniquePropertyName
  }
};
exports.propertyName = propertyName;